import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from 'axios';
import { findStatusTitleById, findStatusTitleByIdForInternalUser } from "../../enums/CaseStatus";
import { useLocation } from "react-router-dom";
import "./boundCases.css";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";
import {MdErrorOutline} from "react-icons/md";

function BoundCases({ open, handleClose, caseDetails, roleId, id }) {
    const [caseData, setCaseData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const caseId = parseInt(urlParams.get('id'));

    useEffect(() => {
        const fetchCaseData = async () => {
            const detailWithUnicId = caseDetails.find(detail => detail.unicId === true);
            if (detailWithUnicId) {
                setIsLoading(true);
                const requestBody = {
                    pageSize: 50,
                    page: 0,
                    filter: [
                        {
                            fieldName: detailWithUnicId.key,
                            stringValue: detailWithUnicId.value,
                            dynamic: true,
                            greaterDateTime: false
                        }
                    ],
                    creteByExpert: false
                };

                try {
                    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/GetAllCasePublic`, requestBody);
                    if (response.data && response.data.success) {
                        const filteredData = response.data.data.result.filter(caseItem => caseItem.id !== caseId);
                        setCaseData(filteredData);
                    }
                } catch (error) {
                    console.error('Error fetching case data:', error);
                } finally {
                    setIsLoading(false);
                }
            } else {
                setIsLoading(false);
            }
        };

        void fetchCaseData();
    }, [caseDetails, id]);

    const formatDate = (dateString) => {
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleCaseNumberClick = (caseId) => {
        window.open(`/dashboard/mycases/casemanager?id=${caseId}`, '_blank');
    };


    return (
        <>
            <Dialog fullWidth maxWidth={caseData.length > 0 ? "lg" : "sm"} style={{ zIndex: 4, minWidth: '100%' }} open={open} onClose={handleClose}>
                <DialogContent>
                    {isLoading ? (
                        <Typography variant="subtitle1" style={{ textAlign: 'center' }}>
                            <LoaderCustomFixed />
                        </Typography>
                    ) : caseData.length > 0 ? (
                        <TableContainer style={{ minWidth: caseData.length > 0 ? 1000 : 500 }} component={Paper}>
                            <Table aria-label="case data table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>განაცხადის ნომერი</TableCell>
                                        <TableCell>განმცხადებელი</TableCell>
                                        <TableCell>სტატუსი</TableCell>
                                        <TableCell>რეგისტრაციის თარიღი</TableCell>
                                        <TableCell>დასრულების თარიღი</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {caseData.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell component="th" scope="row" onClick={() => handleCaseNumberClick(row.id)} className={"case-number-bound"}>
                                                {row.caseNumber}
                                            </TableCell>
                                            <TableCell>{row.requesterName}</TableCell>
                                            <TableCell>{roleId !== 'USER' ? findStatusTitleByIdForInternalUser(row.status) : findStatusTitleById(row.status)}</TableCell>
                                            <TableCell>{formatDate(row.createdAt)}</TableCell>
                                            <TableCell>{formatDate(row.dedline)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography
                            variant="subtitle1"
                            style={{
                                textAlign: 'center',
                                marginTop: '20px',
                                padding: '20px',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px',
                            }}
                        >
                            <MdErrorOutline style={{ fontSize: '24px', color: '#ff4d4f' }} />
                            არაფერი მოიძება!
                        </Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default BoundCases;
